// ShowOutstanding = Only return policy tarnsactions with outstanding balances
// ShowPosted = Only return posted policy transactions
// ShowUnposted = Only return unposted policy transactions
// ShowImported = Only return imported policy transactions
// ShowLatest = Only return lasted policy transactions; i.e. the latest transaction in the latest period
// ShowLapsed = Only return lapse policy transactions
// ShowLapsesAndCancellations = Only return lapse and cancellation policy transactions
// ShowQuotes = Only return quote policy transactions
// ShowTakeUp = Only return takeup policy transactions
// ShowAll = No filter. Return all matching records.
export const FILTER_TYPES = {
	ShowLatest: 'ShowLatest',
	ShowAll: 'ShowAll',
	ShowPosted: 'ShowPosted',
	ShowOutstanding: 'ShowOutstanding',
	ShowUnposted: 'ShowUnposted',
	ShowImported: 'ShowImported',
	ShowLapsed: 'ShowLapsed',
	ShowLapsesAndCancellations: 'ShowLapsesAndCancellations',
	ShowQuotes: 'ShowQuotes',
	ShowTakeUp: 'ShowTakeUp',
};

